import styled from 'styled-components'

export const MainContainer = styled.div`
  form {
    max-width: 540px;

    margin: auto;
    margin-top: ${({ theme }) => theme.spacings[10]};
  }

  .title {
    display: flex;
    font-family: ${({ theme }) => theme.fonts.bloggerSans};
    font-size: 24px;
    font-weight: 700;
    line-height: 26px;
    letter-spacing: 0em;
    text-align: left;
    padding-bottom: ${({ theme }) => theme.spacings[14]};
  }
`

export const ContainerButtons = styled.div`
  width: 100%;

  button {
    width: 100%;
  }

  button:first-of-type {
    margin-bottom: ${({ theme }) => theme.spacings[2]};
  }
`
